/**
 * Leaderboard visibility gate (specs/competitions-hub-client Slice 3).
 *
 * The World Cup hides its global board until 50 players have joined ("coming soon"),
 * which would make a young season pool look permanently empty. Extracted as a pure
 * function so both thresholds are testable.
 */

/** World Cup default — unchanged behavior when no threshold is passed. */
export const LEADERBOARD_DEFAULT_MIN_SHOW_THRESHOLD = 50;

/** Season pools and other competitions start small; show the board almost immediately. */
export const COMPETITION_LEADERBOARD_MIN_SHOW_THRESHOLD = 3;

export function shouldShowCompetitionLeaderboard(
  participantCount: number,
  threshold: number = LEADERBOARD_DEFAULT_MIN_SHOW_THRESHOLD,
): boolean {
  return participantCount >= threshold;
}
